<!-- 浮点数字输入框:非负数-->
<script>
import { Input } from 'element-ui';

export default {
    name: 'ElNumberInput',
    extends: Input,
    watch: {
        value() {
            this.transNum();
            // this.phoneAutoCompleteHandle();
        },
    },
    methods: {
        // 转换值：浮点数限制
        transNum() {
            // 清除“数字”和“.”以外的字符,只保留第一个. 清除多余的,防止输入一个点后再输入多余的点
            if (this.value) {
                let res = this.value.toString().replace(/[^\d.]/g, '');
                res = res.replace(/\.{2,}/g, '.');
                res = res.replace('.', '$#$').replace(/\./g, '')
                    .replace('$#$', '.');
                this.$emit('input', res);
                this.$nextTick(this.setNativeInputValue);
            }
        },
    },
    // mounted() {
    //     const inputDom = this.$refs.input;
    //     inputDom.onkeydown = function (ev) {
    //         ev.stopPropagation();
    //         const code = ev.keyCode;
    //         // console.log(code);
    //         if ((code >= 48 && code <= 57) || (code >= 96 && code <= 105) || (code === 8 || code === 46 || code === 37 || code === 39 || code === 110)) return true;
    //         return false;
    //     };
    // },
};
</script>
